import React from "react";
import GeneralInfo from "./GeneralInfo";
import SocialMedia from "./SocialMedia";
import ButtonSection from "./ButtonSection";
import AccountInfo from "./AccountInfo";

const PersonalInfo = () => {
    return (
        <div>
            <AccountInfo />
            <GeneralInfo />
            <SocialMedia />
            <ButtonSection />
        </div>
    );
};

export default PersonalInfo;
